module.exports = "/_next/static/resources/photo-1-10745e06852c6b0e83c215ca586e8e7c.webp";